module.exports = __webpack_public_path__ + "static/media/level-8.24b66679.glb";